// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { GroupControl } from "./group-control";

export class NormalGroupControl implements flatbuffers.IUnpackableObject<NormalGroupControlT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NormalGroupControl {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNormalGroupControl(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalGroupControl,
  ): NormalGroupControl {
    return (obj || new NormalGroupControl()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsNormalGroupControl(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalGroupControl,
  ): NormalGroupControl {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NormalGroupControl()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  message(): GroupControl {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : GroupControl.SEC;
  }

  static startNormalGroupControl(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMessage(builder: flatbuffers.Builder, message: GroupControl) {
    builder.addFieldInt16(0, message, GroupControl.SEC);
  }

  static endNormalGroupControl(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNormalGroupControl(
    builder: flatbuffers.Builder,
    message: GroupControl,
  ): flatbuffers.Offset {
    NormalGroupControl.startNormalGroupControl(builder);
    NormalGroupControl.addMessage(builder, message);
    return NormalGroupControl.endNormalGroupControl(builder);
  }

  unpack(): NormalGroupControlT {
    return new NormalGroupControlT(this.message());
  }

  unpackTo(_o: NormalGroupControlT): void {
    _o.message = this.message();
  }

  unpackFields(...fields: string[]): NormalGroupControlT {
    const t = new NormalGroupControlT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    return t;
  }
}

export class NormalGroupControlT implements flatbuffers.IGeneratedObject {
  constructor(public message: GroupControl = GroupControl.SEC) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return NormalGroupControl.createNormalGroupControl(builder, this.message);
  }

  clone(): NormalGroupControlT {
    const obj = new NormalGroupControlT();
    obj.message = this.message;
    return obj;
  }

  equals(other: NormalGroupControlT): boolean {
    if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyNormalGroupControl(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
